import { useQuery } from "@tanstack/react-query";
import type { UnreadCount } from "@spare-cart/contracts/notifications";
import { apiClient } from "@core/api";
import { SessionStatus, selectStatus, useSession } from "@core/auth";
import { notificationKeys } from "./notificationKeys";

export const useUnreadCount = () => {
  const status = useSession(selectStatus);
  return useQuery({
    queryKey: notificationKeys.unreadCount(),
    queryFn: () =>
      apiClient.get<UnreadCount>("/notifications/unread-count", {
        query: { excludeAdminTypes: true },
      }),
    enabled: status === SessionStatus.AUTHENTICATED,
  });
};
